import { useEffect, useState } from "react";
import { usePayment } from "../../../../../APIContext/PaymentContext";
import Swal from "sweetalert2";
import "./index.css";
import AddCard from "./AddCard";

const PaymentMethod = () => {
  const { getPaymentMethods, removeCard } = usePayment();
  const [cards, setCards] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const [addModal, setAddModal] = useState(false);

  const fetchCards = async () => {
    setIsFetching(true);
    const data = await getPaymentMethods();
    if (data) setCards(data);
    setIsFetching(false);
  };
  // Fetch saved cards
  useEffect(() => {
    fetchCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Remove card
  const handleRemoveCard = async (cardId) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "This card will be removed permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
    });

    if (confirmed.isConfirmed) {
      const success = await removeCard(cardId);
      if (success) {
        setCards((prev) => prev.filter((card) => card.id !== cardId));
      }
    }
  };

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          {/* Header */}
          <div className="player-header">
            <h2 className="text-clip">Saved Payment Methods</h2>
            <button
              className="add-player-btn"
              onClick={() => setAddModal((pre) => !pre)}
            >
              Add New Card
            </button>
            {addModal && (
              <AddCard setOpen={setAddModal} onSuccess={fetchCards} />
            )}
          </div>

          {/* Body */}
          <div className="saved-cards-container">
            {isFetching ? (
              <p className="loading-text text-clip">Loading saved cards...</p>
            ) : cards.length === 0 ? (
              <p className="empty-text text-clip">No saved cards found.</p>
            ) : (
              <div className="cards-grid">
                {cards.map((card) => (
                  <div key={card.id} className="card-item brightness">
                    <div className="card-header">
                      <span className="card-brand text-clip">
                        {card.brand.toUpperCase()}
                      </span>
                      <span className="card-last4 text-clip">
                        •••• {card.last4}
                      </span>
                    </div>

                    <div className="card-details">
                      <div className="card-row">
                        <label className="text-clip">Expiry</label>
                        <span className="text-clip">
                          {`${card.exp_month
                            .toString()
                            .padStart(2, "0")}/${card.exp_year}`}
                        </span>
                      </div>

                      <div className="card-row">
                        <label className="text-clip">CVC</label>
                        <span className="text-clip">•••</span>
                      </div>

                      {card.is_default && (
                        <span className="default-badge">
                          <span className="text-clip">Default</span>
                        </span>
                      )}
                    </div>

                    <div className="card-actions">
                      <button
                        className="btn remove-btn"
                        onClick={() => handleRemoveCard(card.id)}
                      >
                        <span>Remove Card</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentMethod;
